export default __webpack_public_path__ + "static/media/desktop.de263e16.png";